import React from 'react';
import styled from 'styled-components';
import { ErrorPanel } from '@sorted/sorted-ui';

const PanelWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

const ErrorPage = ({ children, ...props }) => (
	<PanelWrapper>
		<ErrorPanel {...props}>{children}</ErrorPanel>
	</PanelWrapper>
);

export default ErrorPage;
